const features = [
  {
    icon: 'ri-4k-line',
    title: '超清画质',
    desc: '支持1080P与4K超清播放，每一帧都清晰细腻，给您影院级的观剧体验，不错过任何画面细节。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速加载',
    desc: '采用先进的CDN加速与智能预加载技术，点击即播无需等待，告别转圈加载的烦躁体验。',
  },
  {
    icon: 'ri-folders-line',
    title: '海量片库',
    desc: '收录超过两万部国内外热门剧集，涵盖国产、韩剧、美剧、日剧、泰剧等全品类，每日同步更新。',
  },
  {
    icon: 'ri-device-line',
    title: '多端同步',
    desc: '手机、平板、电脑无缝切换，追剧进度自动同步，随时随地打开就能接着看，追剧不停歇。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">为什么选择香蕉影视</h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">我们致力于为用户打造极致的在线追剧体验，四大核心优势让追剧更简单</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((item) => (
            <div key={item.title} className="group p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer">
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-white transition-colors">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-foreground-500 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}